import { Locale, toLocale } from '@common/models/locale'

// config init
const CONFIG = __APP_CONFIG__

export const CURRENT_ENV = CONFIG.appInfo.env
export const CURRENT_MUTATION = CONFIG.appInfo.mutation
export const IS_LOCAL_ENV = CURRENT_ENV === 'local'
export const CURRENT_LOCALE: Locale = toLocale(CONFIG.locale)
export const CURRENT_THEME = CONFIG.currentTheme
export const TIMEZONE = CONFIG.timeZone

export const APP_VERSION = CONFIG.appInfo.version
export const API_BASE_URL = CONFIG.api.orderTracking
export const ESHOP_URL = CONFIG.eshopUrl
export const SENTRY_DSN = CONFIG.sentry.dsn
export const SENTRY_ENV = CONFIG.sentry.env
export const SENTRY_RELEASE = `${CONFIG.appInfo.name}@${CONFIG.appInfo.version}`

export const GTM = CONFIG.gtm
export const GMAPS = CONFIG.gmaps
export const ROBOT = CONFIG.robot
export const CALL_CENTER = CONFIG.callCenter

export const SHOW_ONLY_TRANSLATED_STATUSES =
  CONFIG.showOnlyTranslatedStatuses === true || CONFIG.showOnlyTranslatedStatuses === 'true'
export const MUTATION_CONFIG = CONFIG.mutation
